

// // // // regionApi.js

// // // const API_BASE = "https://assocham.org/assocham_backend/api";

// // // // Explicit overrides for states where the frontend slug differs from the DB slug
// // // const SLUG_OVERRIDES = {
// // //   "maharashtra": "maharashtra-state-council",
// // //   // "tamil-nadu": "tamil-nadu-state-development-council",
// // //   // "telangana": "telangana-state-development-council",
// // //   // Add others if they don't follow the pattern
// // //   // "andhra-pradesh": "andhra-pradesh-state-development-council",
// // //   // "karnataka": "karnataka-state-development-council",
// // // };

// // // /**
// // //  * Convert a frontend slug (e.g., "tamil-nadu") to the database slug.
// // //  * If there's no explicit override, we append "-state-development-council"
// // //  * unless the slug already ends with that string.
// // //  */
// // // function getDbSlug(frontendSlug) {
// // //   if (!frontendSlug) return frontendSlug;
// // //   const trimmed = frontendSlug.trim();
// // //   const override = SLUG_OVERRIDES[trimmed];
// // //   if (override) return override;
// // //   // If it doesn't already end with "-state-development-council", add it.
// // //   if (!trimmed.endsWith('-state-development-council')) {
// // //     return `${trimmed}-state-development-council`;
// // //   }
// // //   return trimmed;
// // // }

// // // export async function getRegionBySlug(slug) {
// // //   if (!slug) return null;
// // //   const dbSlug = getDbSlug(slug);
// // //   console.log('[getRegionBySlug] frontend slug:', slug, '→ DB slug:', dbSlug);

// // //   try {
// // //     const res = await fetch(`${API_BASE}/get_region.php?slug=${encodeURIComponent(dbSlug)}`);
// // //     const json = await res.json();
// // //     if (!json.success) return null;
// // //     return json.data;
// // //   } catch (err) {
// // //     console.error("getRegionBySlug error:", err);
// // //     return null;
// // //   }
// // // }

// // // export async function getCouncilLeadership(slug) {
// // //   if (!slug) return [];
// // //   const dbSlug = getDbSlug(slug);
// // //   try {
// // //     const res = await fetch(`${API_BASE}/getCouncilLeadership-state.php?slug=${encodeURIComponent(dbSlug)}`);
// // //     const json = await res.json();
// // //     if (json.success) {
// // //       return json.data;
// // //     }
// // //     return [];
// // //   } catch (error) {
// // //     console.error('Failed to fetch council leadership:', error);
// // //     return [];
// // //   }
// // // }

// // // export async function fetchRegionEvents(slug) {
// // //   if (!slug) return [];
// // //   const dbSlug = getDbSlug(slug);
// // //   console.log('[fetchRegionEvents] frontend slug:', slug, '→ DB slug:', dbSlug);

// // //   try {
// // //     const res = await fetch(`${API_BASE}/get_region_events.php?slug=${encodeURIComponent(dbSlug)}`);
// // //     const json = await res.json();
// // //     if (!json.success) {
// // //       console.warn('fetchRegionEvents API error:', json.message);
// // //       return [];
// // //     }
// // //     return json.data || [];
// // //   } catch (err) {
// // //     console.error("fetchRegionEvents error:", err);
// // //     return [];
// // //   }
// // // }

// // // export async function fetchRegionPublications(slug) {
// // //   if (!slug) return [];
// // //   const dbSlug = getDbSlug(slug);
// // //   try {
// // //     const res = await fetch(`${API_BASE}/get_region_publications.php?slug=${encodeURIComponent(dbSlug)}`);
// // //     const json = await res.json();
// // //     if (!json.success) {
// // //       console.warn('fetchRegionPublications API error:', json.message);
// // //       return [];
// // //     }
// // //     return json.data || [];
// // //   } catch (err) {
// // //     console.error("fetchRegionPublications error:", err);
// // //     return [];
// // //   }
// // // }

// // // export async function fetchRegionPressReleases(slug) {
// // //   if (!slug) return [];
// // //   const dbSlug = getDbSlug(slug);
// // //   try {
// // //     const res = await fetch(`${API_BASE}/get_region_press_releases.php?slug=${encodeURIComponent(dbSlug)}`);
// // //     const json = await res.json();
// // //     if (!json.success) {
// // //       console.warn('fetchRegionPressReleases API error:', json.message);
// // //       return [];
// // //     }
// // //     return json.data || [];
// // //   } catch (err) {
// // //     console.error("fetchRegionPressReleases error:", err);
// // //     return [];
// // //   }
// // // }

// // // export async function fetchRegionPressCoverage(slug) {
// // //   if (!slug) return [];
// // //   const dbSlug = getDbSlug(slug);
// // //   try {
// // //     const res = await fetch(`${API_BASE}/get_region_press_coverage.php?slug=${encodeURIComponent(dbSlug)}`);
// // //     const json = await res.json();
// // //     if (!json.success) {
// // //       console.warn('fetchRegionPressCoverage API error:', json.message);
// // //       return [];
// // //     }
// // //     return json.data || [];
// // //   } catch (err) {
// // //     console.error("fetchRegionPressCoverage error:", err);
// // //     return [];
// // //   }
// // // }






// // // new code 





// // // regionApi.js

// // const API_BASE = "https://assocham.org/assocham_backend/api";

// // // Explicit overrides for states where the frontend slug differs from the DB slug
// // const SLUG_OVERRIDES = {
// //   "maharashtra": "maharashtra-state-council",
// //   // "tamil-nadu": "tamil-nadu-state-development-council",
// //   // "telangana": "telangana-state-development-council",
// //   // "andhra-pradesh": "andhra-pradesh-state-development-council",
// //   // "karnataka": "karnataka-state-development-council",
// // };

// // /**
// //  * Convert a frontend slug (e.g., "tamil-nadu") to the database slug.
// //  */
// // function getDbSlug(frontendSlug) {
// //   if (!frontendSlug) return frontendSlug;
// //   const trimmed = frontendSlug.trim();
// //   const override = SLUG_OVERRIDES[trimmed];
// //   if (override) return override;
// //   if (!trimmed.endsWith('-state-development-council')) {
// //     return `${trimmed}-state-development-council`;
// //   }
// //   return trimmed;
// // }

// // /* ------------------------------------------------------------------
// //  * CLEANUP HELPERS
// //  * Purane / double-escaped data ko saaf karne ke liye.
// //  * Example:
// //  *   country\'s      -> country's
// //  *   <\/p>           -> </p>
// //  *   \\\\            -> \\
// //  * ------------------------------------------------------------------ */

// // /**
// //  * Clean a single string value coming from the API.
// //  * - Convert \'  -> '
// //  * - Convert \"  -> "
// //  * - Convert \/  -> /
// //  * - Collapse \\\\ -> \\
// //  */
// // function cleanString(value) {
// //   if (typeof value !== 'string') return value;

// //   let out = value;

// //   // Fix over-escaped slashes (\/ and \\/)
// //   out = out.replace(/\\+\//g, '/');

// //   // Fix backslash-escaped single quotes: \' -> '
// //   // Handles multiple backslashes: \\' -> '
// //   out = out.replace(/\\+'/g, "'");

// //   // Fix backslash-escaped double quotes: \" -> "
// //   out = out.replace(/\\+"/g, '"');

// //   // Collapse duplicate backslashes: \\\\ -> \\
// //   out = out.replace(/\\\\{2,}/g, '\\\\');

// //   return out;
// // }

// // /**
// //  * Recursively clean all string fields in an object / array.
// //  */
// // function cleanDeep(data) {
// //   if (data == null) return data;

// //   if (typeof data === 'string') return cleanString(data);

// //   if (Array.isArray(data)) return data.map(cleanDeep);

// //   if (typeof data === 'object') {
// //     const out = {};
// //     for (const key of Object.keys(data)) {
// //       out[key] = cleanDeep(data[key]);
// //     }
// //     return out;
// //   }

// //   return data;
// // }

// // /* ------------------------------------------------------------------
// //  * API FUNCTIONS
// //  * ------------------------------------------------------------------ */

// // export async function getRegionBySlug(slug) {
// //   if (!slug) return null;
// //   const dbSlug = getDbSlug(slug);
// //   console.log('[getRegionBySlug] frontend slug:', slug, '→ DB slug:', dbSlug);

// //   try {
// //     const res = await fetch(`${API_BASE}/get_region.php?slug=${encodeURIComponent(dbSlug)}`);
// //     const json = await res.json();
// //     if (!json.success) return null;
// //     return cleanDeep(json.data);
// //   } catch (err) {
// //     console.error("getRegionBySlug error:", err);
// //     return null;
// //   }
// // }

// // export async function getCouncilLeadership(slug) {
// //   if (!slug) return [];
// //   const dbSlug = getDbSlug(slug);
// //   try {
// //     const res = await fetch(`${API_BASE}/getCouncilLeadership-state.php?slug=${encodeURIComponent(dbSlug)}`);
// //     const json = await res.json();
// //     if (json.success) {
// //       return cleanDeep(json.data) || [];
// //     }
// //     return [];
// //   } catch (error) {
// //     console.error('Failed to fetch council leadership:', error);
// //     return [];
// //   }
// // }

// // export async function fetchRegionEvents(slug) {
// //   if (!slug) return [];
// //   const dbSlug = getDbSlug(slug);
// //   console.log('[fetchRegionEvents] frontend slug:', slug, '→ DB slug:', dbSlug);

// //   try {
// //     const res = await fetch(`${API_BASE}/get_region_events.php?slug=${encodeURIComponent(dbSlug)}`);
// //     const json = await res.json();
// //     if (!json.success) {
// //       console.warn('fetchRegionEvents API error:', json.message);
// //       return [];
// //     }
// //     return cleanDeep(json.data) || [];
// //   } catch (err) {
// //     console.error("fetchRegionEvents error:", err);
// //     return [];
// //   }
// // }

// // export async function fetchRegionPublications(slug) {
// //   if (!slug) return [];
// //   const dbSlug = getDbSlug(slug);
// //   try {
// //     const res = await fetch(`${API_BASE}/get_region_publications.php?slug=${encodeURIComponent(dbSlug)}`);
// //     const json = await res.json();
// //     if (!json.success) {
// //       console.warn('fetchRegionPublications API error:', json.message);
// //       return [];
// //     }
// //     return cleanDeep(json.data) || [];
// //   } catch (err) {
// //     console.error("fetchRegionPublications error:", err);
// //     return [];
// //   }
// // }

// // export async function fetchRegionPressReleases(slug) {
// //   if (!slug) return [];
// //   const dbSlug = getDbSlug(slug);
// //   try {
// //     const res = await fetch(`${API_BASE}/get_region_press_releases.php?slug=${encodeURIComponent(dbSlug)}`);
// //     const json = await res.json();
// //     if (!json.success) {
// //       console.warn('fetchRegionPressReleases API error:', json.message);
// //       return [];
// //     }
// //     return cleanDeep(json.data) || [];
// //   } catch (err) {
// //     console.error("fetchRegionPressReleases error:", err);
// //     return [];
// //   }
// // }

// // export async function fetchRegionPressCoverage(slug) {
// //   if (!slug) return [];
// //   const dbSlug = getDbSlug(slug);
// //   try {
// //     const res = await fetch(`${API_BASE}/get_region_press_coverage.php?slug=${encodeURIComponent(dbSlug)}`);
// //     const json = await res.json();
// //     if (!json.success) {
// //       console.warn('fetchRegionPressCoverage API error:', json.message);
// //       return [];
// //     }
// //     return cleanDeep(json.data) || [];
// //   } catch (err) {
// //     console.error("fetchRegionPressCoverage error:", err);
// //     return [];
// //   }
// // }




// // new code 




// // regionApi.js

// const API_BASE = "https://assocham.org/assocham_backend/api";

// // DB `regions.id` never changes even when a slug is renamed, typo'd, or
// // duplicated — so it's the ONE reliable way to point a frontend route at
// // the right row. Guessing a slug pattern (getDbSlug fallback below) breaks
// // the moment a state's real DB slug doesn't follow the guessed pattern —
// // that's exactly what happened with Maharashtra ("maharashtra-state-
// // council") and West Bengal ("west-bangal-council").
// //
// // Source (run whenever a new state/region is added or its id changes):
// //   SELECT id, region_name, slug FROM regions WHERE deleted = 0 AND status = 1 ORDER BY region_name;
// //
// // NOTE: the keys below are my best guess at your frontend route slugs
// // (kebab-case of region_name). Double check these three against your
// // `stateNames` / router config and fix the KEY (left side) if it differs —
// // the id (right side, from the DB) is already correct either way:
// //   - "jammu-kashmir"  (could be "jammu-and-kashmir" in your routes)
// //   - "central-region" (could be "central-region-delhi-up" or similar)
// //   - "north-east"     (could be "north-east-region")
// const STATE_ID_MAP = {
//   "andhra-pradesh": 19,
//   "central-region": 24,     // verify key — see note above
//   "chandigarh": 13,
//   "chhattisgarh": 25,
//   "delhi": 4,
//   "goa": 9,
//   "gujarat": 3,
//   "haryana": 16,
//   "himachal-pradesh": 23,
//   "jammu-kashmir": 10,       // verify key — see note above
//   "karnataka": 1,
//   "kerala": 34,
//   "ladakh": 33,
//   "madhya-pradesh": 11,
//   "maharashtra": 42,
//   "north-east": 15,          // verify key — see note above
//   "odisha": 6,
//   "pondicherry": 39,
//   "punjab": 5,
//   "rajasthan": 18,
//   "tamil-nadu": 17,
//   "telangana": 21,
//   "uttar-pradesh": 7,
//   "uttarakhand": 26,
//   "west-bengal": 27,
// };

// // LAST-RESORT fallback for any state NOT in STATE_ID_MAP above (e.g. a new
// // region added later, before its id is added here).
// const SLUG_OVERRIDES = {
//   // "some-new-state": "its-real-db-slug",
// };

// /**
//  * Convert a frontend slug (e.g., "tamil-nadu") to a GUESSED database slug.
//  * Only used as a last resort when the state isn't in STATE_ID_MAP yet —
//  * this blind-suffix guessing is exactly what caused the Maharashtra and
//  * West Bengal bugs, so always prefer adding the state's real id to
//  * STATE_ID_MAP over relying on this function.
//  */
// function getDbSlug(frontendSlug) {
//   if (!frontendSlug) return frontendSlug;
//   const trimmed = frontendSlug.trim();
//   const override = SLUG_OVERRIDES[trimmed];
//   if (override) return override;
//   if (!trimmed.endsWith('-state-development-council')) {
//     return `${trimmed}-state-development-council`;
//   }
//   return trimmed;
// }

// /* ------------------------------------------------------------------
//  * CLEANUP HELPERS
//  * Purane / double-escaped data ko saaf karne ke liye.
//  * Example:
//  *   country\'s      -> country's
//  *   <\/p>           -> </p>
//  *   \\\\            -> \\
//  * ------------------------------------------------------------------ */

// function cleanString(value) {
//   if (typeof value !== 'string') return value;

//   let out = value;

//   // Fix over-escaped slashes (\/ and \\/)
//   out = out.replace(/\\+\//g, '/');

//   // Fix backslash-escaped single quotes: \' -> '
//   out = out.replace(/\\+'/g, "'");

//   // Fix backslash-escaped double quotes: \" -> "
//   out = out.replace(/\\+"/g, '"');

//   // Collapse duplicate backslashes: \\\\ -> \\
//   out = out.replace(/\\\\{2,}/g, '\\\\');

//   return out;
// }

// function cleanDeep(data) {
//   if (data == null) return data;
//   if (typeof data === 'string') return cleanString(data);
//   if (Array.isArray(data)) return data.map(cleanDeep);
//   if (typeof data === 'object') {
//     const out = {};
//     for (const key of Object.keys(data)) {
//       out[key] = cleanDeep(data[key]);
//     }
//     return out;
//   }
//   return data;
// }

// /* ------------------------------------------------------------------
//  * ID-FIRST SLUG RESOLUTION
//  * ------------------------------------------------------------------ */

// // Per-page-load cache: frontendSlug -> resolved region row (or null once we
// // know it isn't in STATE_ID_MAP and we've fallen back to guessing).
// const regionCache = {};

// /**
//  * Resolve a frontend slug to the real region row.
//  * 1. If we have its DB id mapped, fetch by id — exact, unambiguous.
//  * 2. Otherwise return null so callers fall back to slug guessing.
//  * The result (including the row's real `slug`) is cached for this page
//  * load so every fetch* function below reuses the same confirmed-correct
//  * slug instead of each guessing independently.
//  */
// async function resolveRegion(frontendSlug) {
//   if (regionCache[frontendSlug] !== undefined) return regionCache[frontendSlug];

//   const id = STATE_ID_MAP[frontendSlug];
//   if (id) {
//     try {
//       const res = await fetch(`${API_BASE}/get_region.php?id=${encodeURIComponent(id)}`);
//       const json = await res.json();
//       if (json.success && json.data) {
//         const cleaned = cleanDeep(json.data);
//         regionCache[frontendSlug] = cleaned;
//         return cleaned;
//       }
//     } catch (err) {
//       console.error("resolveRegion (by id) error:", err);
//     }
//   }

//   regionCache[frontendSlug] = null;
//   return null;
// }

// async function resolveDbSlug(frontendSlug) {
//   const region = await resolveRegion(frontendSlug);
//   return region?.slug || getDbSlug(frontendSlug);
// }

// /* ------------------------------------------------------------------
//  * API FUNCTIONS
//  * ------------------------------------------------------------------ */

// export async function getRegionBySlug(slug) {
//   if (!slug) return null;

//   // Already resolved via id above -> use that data directly, no extra call.
//   const cached = await resolveRegion(slug);
//   if (cached) {
//     console.log('[getRegionBySlug] frontend slug:', slug, '→ resolved by DB id, real slug:', cached.slug);
//     return cached;
//   }

//   const dbSlug = getDbSlug(slug);
//   console.log('[getRegionBySlug] frontend slug:', slug, '→ DB slug (guessed, no id mapped):', dbSlug);

//   try {
//     const res = await fetch(`${API_BASE}/get_region.php?slug=${encodeURIComponent(dbSlug)}`);
//     const json = await res.json();
//     if (!json.success) return null;
//     return cleanDeep(json.data);
//   } catch (err) {
//     console.error("getRegionBySlug error:", err);
//     return null;
//   }
// }

// export async function getCouncilLeadership(slug) {
//   if (!slug) return [];
//   const dbSlug = await resolveDbSlug(slug);
//   try {
//     const res = await fetch(`${API_BASE}/getCouncilLeadership-state.php?slug=${encodeURIComponent(dbSlug)}`);
//     const json = await res.json();
//     if (json.success) {
//       return cleanDeep(json.data) || [];
//     }
//     return [];
//   } catch (error) {
//     console.error('Failed to fetch council leadership:', error);
//     return [];
//   }
// }

// export async function fetchRegionEvents(slug) {
//   if (!slug) return [];
//   const dbSlug = await resolveDbSlug(slug);
//   console.log('[fetchRegionEvents] frontend slug:', slug, '→ DB slug:', dbSlug);

//   try {
//     const res = await fetch(`${API_BASE}/get_region_events.php?slug=${encodeURIComponent(dbSlug)}`);
//     const json = await res.json();
//     if (!json.success) {
//       console.warn('fetchRegionEvents API error:', json.message);
//       return [];
//     }
//     return cleanDeep(json.data) || [];
//   } catch (err) {
//     console.error("fetchRegionEvents error:", err);
//     return [];
//   }
// }

// export async function fetchRegionPublications(slug) {
//   if (!slug) return [];
//   const dbSlug = await resolveDbSlug(slug);
//   try {
//     const res = await fetch(`${API_BASE}/get_region_publications.php?slug=${encodeURIComponent(dbSlug)}`);
//     const json = await res.json();
//     if (!json.success) {
//       console.warn('fetchRegionPublications API error:', json.message);
//       return [];
//     }
//     return cleanDeep(json.data) || [];
//   } catch (err) {
//     console.error("fetchRegionPublications error:", err);
//     return [];
//   }
// }

// export async function fetchRegionPressReleases(slug) {
//   if (!slug) return [];
//   const dbSlug = await resolveDbSlug(slug);
//   try {
//     const res = await fetch(`${API_BASE}/get_region_press_releases.php?slug=${encodeURIComponent(dbSlug)}`);
//     const json = await res.json();
//     if (!json.success) {
//       console.warn('fetchRegionPressReleases API error:', json.message);
//       return [];
//     }
//     return cleanDeep(json.data) || [];
//   } catch (err) {
//     console.error("fetchRegionPressReleases error:", err);
//     return [];
//   }
// }

// export async function fetchRegionPressCoverage(slug) {
//   if (!slug) return [];
//   const dbSlug = await resolveDbSlug(slug);
//   try {
//     const res = await fetch(`${API_BASE}/get_region_press_coverage.php?slug=${encodeURIComponent(dbSlug)}`);
//     const json = await res.json();
//     if (!json.success) {
//       console.warn('fetchRegionPressCoverage API error:', json.message);
//       return [];
//     }
//     return cleanDeep(json.data) || [];
//   } catch (err) {
//     console.error("fetchRegionPressCoverage error:", err);
//     return [];
//   }
// }




// export async function fetchRegionOffice(slug) {
//   if (!slug) return null;
//   const res = await fetch(`https://assocham.org/assocham_backend/api/region-office.php?slug=${encodeURIComponent(slug)}`);
//   if (!res.ok) return null;
//   const json = await res.json();
//   return json?.success ? json.data : null;
// }




// new new code 






const API_BASE =
  (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.VITE_API_BASE) ||
  'https://assocham.org/assocham_backend/api';

const STATE_ID_MAP = {
  "andhra-pradesh": 19,
  "central-region": 24,     // verify key — see note above
  "chandigarh": 13,
  "chhattisgarh": 25,
  "delhi": 4,
  "goa": 9,
  "gujarat": 3,
  "haryana": 16,
  "himachal-pradesh": 23,
  "jammu-kashmir": 10,       // verify key — see note above
  "karnataka": 1,
  "kerala": 34,
  "ladakh": 33,
  "madhya-pradesh": 11,
  "maharashtra": 42,
  "north-east": 15,          // verify key — see note above
  "odisha": 6,
  "pondicherry": 39,
  "punjab": 5,
  "rajasthan": 18,
  "tamil-nadu": 17,
  "telangana": 21,
  "uttar-pradesh": 7,
  "uttarakhand": 26,
  "west-bengal": 27,
};

// LAST-RESORT fallback for any state NOT in STATE_ID_MAP above (e.g. a new
// region added later, before its id is added here).
const SLUG_OVERRIDES = {
  // "some-new-state": "its-real-db-slug",
};

/**
 * Convert a frontend slug (e.g., "tamil-nadu") to a GUESSED database slug.
 * Only used as a last resort when the state isn't in STATE_ID_MAP yet —
 * always prefer adding the state's real id to STATE_ID_MAP.
 */
function getDbSlug(frontendSlug) {
  if (!frontendSlug) return frontendSlug;
  const trimmed = frontendSlug.trim();
  const override = SLUG_OVERRIDES[trimmed];
  if (override) return override;
  if (!trimmed.endsWith('-state-development-council')) {
    return `${trimmed}-state-development-council`;
  }
  return trimmed;
}

/* ------------------------------------------------------------------
 * CLEANUP HELPERS
 * Purane / double-escaped data ko saaf karne ke liye.
 * ------------------------------------------------------------------ */

function cleanString(value) {
  if (typeof value !== 'string') return value;

  let out = value;

  // Fix over-escaped slashes (\/ and \\/)
  out = out.replace(/\\+\//g, '/');

  // Fix backslash-escaped single quotes: \' -> '
  out = out.replace(/\\+'/g, "'");

  // Fix backslash-escaped double quotes: \" -> "
  out = out.replace(/\\+"/g, '"');

  // Collapse duplicate backslashes: \\\\ -> \\
  out = out.replace(/\\\\{2,}/g, '\\\\');

  return out;
}

function cleanDeep(data) {
  if (data == null) return data;
  if (typeof data === 'string') return cleanString(data);
  if (Array.isArray(data)) return data.map(cleanDeep);
  if (typeof data === 'object') {
    const out = {};
    for (const key of Object.keys(data)) {
      out[key] = cleanDeep(data[key]);
    }
    return out;
  }
  return data;
}

/* ------------------------------------------------------------------
 * ID-FIRST SLUG RESOLUTION
 * ------------------------------------------------------------------ */

// Per-page-load cache: frontendSlug -> Promise<region row | null>.
// Caching the PROMISE means parallel callers share one network request.
const regionCache = {};

async function fetchRegionById(frontendSlug) {
  const id = STATE_ID_MAP[frontendSlug];
  if (!id) return null;
  try {
    const res = await fetch(`${API_BASE}/get_region.php?id=${encodeURIComponent(id)}`);
    if (!res.ok) return null;
    const json = await res.json();
    if (json.success && json.data) return cleanDeep(json.data);
  } catch (err) {
    console.error('resolveRegion (by id) error:', err);
  }
  return null;
}

/**
 * Resolve a frontend slug to the real region row.
 * 1. If we have its DB id mapped, fetch by id — exact, unambiguous.
 * 2. Otherwise return null so callers fall back to slug guessing.
 * Failed lookups are NOT cached, so a later call can retry.
 */
function resolveRegion(frontendSlug) {
  if (!frontendSlug) return Promise.resolve(null);
  if (regionCache[frontendSlug]) return regionCache[frontendSlug];

  const p = fetchRegionById(frontendSlug).then((row) => {
    if (!row) delete regionCache[frontendSlug];
    return row;
  });
  regionCache[frontendSlug] = p;
  return p;
}

async function resolveDbSlug(frontendSlug) {
  const region = await resolveRegion(frontendSlug);
  return region?.slug || getDbSlug(frontendSlug);
}

/* ------------------------------------------------------------------
 * API FUNCTIONS
 * ------------------------------------------------------------------ */

export async function getRegionBySlug(slug) {
  if (!slug) return null;

  // Already resolved via id -> use that data directly, no extra call.
  const cached = await resolveRegion(slug);
  if (cached) return cached;

  const dbSlug = getDbSlug(slug);

  try {
    const res = await fetch(`${API_BASE}/get_region.php?slug=${encodeURIComponent(dbSlug)}`);
    if (!res.ok) return null;
    const json = await res.json();
    if (!json.success || !json.data) return null;
    return cleanDeep(json.data);
  } catch (err) {
    console.error('getRegionBySlug error:', err);
    return null;
  }
}

export async function getCouncilLeadership(slug) {
  if (!slug) return [];
  const dbSlug = await resolveDbSlug(slug);
  try {
    const res = await fetch(`${API_BASE}/getCouncilLeadership-state.php?slug=${encodeURIComponent(dbSlug)}`);
    if (!res.ok) return [];
    const json = await res.json();
    if (json.success) {
      return cleanDeep(json.data) || [];
    }
    return [];
  } catch (error) {
    console.error('Failed to fetch council leadership:', error);
    return [];
  }
}

async function fetchRegionList(endpoint, slug, label) {
  if (!slug) return [];
  const dbSlug = await resolveDbSlug(slug);
  try {
    const res = await fetch(`${API_BASE}/${endpoint}?slug=${encodeURIComponent(dbSlug)}`);
    if (!res.ok) return [];
    const json = await res.json();
    if (!json.success) {
      console.warn(`${label} API error:`, json.message);
      return [];
    }
    const cleaned = cleanDeep(json.data);
    return Array.isArray(cleaned) ? cleaned : [];
  } catch (err) {
    console.error(`${label} error:`, err);
    return [];
  }
}

export function fetchRegionEvents(slug) {
  return fetchRegionList('get_region_events.php', slug, 'fetchRegionEvents');
}

export function fetchRegionPublications(slug) {
  return fetchRegionList('get_region_publications.php', slug, 'fetchRegionPublications');
}

export function fetchRegionPressReleases(slug) {
  return fetchRegionList('get_region_press_releases.php', slug, 'fetchRegionPressReleases');
}

export function fetchRegionPressCoverage(slug) {
  return fetchRegionList('get_region_press_coverage.php', slug, 'fetchRegionPressCoverage');
}

async function requestOffice(slugValue) {
  try {
    const res = await fetch(`${API_BASE}/region-office.php?slug=${encodeURIComponent(slugValue)}`);
    if (!res.ok) return null;
    const json = await res.json();
    return json?.success && json.data ? cleanDeep(json.data) : null;
  } catch (err) {
    console.error('fetchRegionOffice error:', err);
    return null;
  }
}

export async function fetchRegionOffice(slug) {
  if (!slug) return null;
  // 1) real DB slug (resolved by id)  2) plain frontend slug
  const dbSlug = await resolveDbSlug(slug);
  const first = await requestOffice(dbSlug);
  if (first) return first;
  if (dbSlug !== slug) return requestOffice(slug);
  return null;
}